import {
  type IpWhitelistAddressValidationError,
  validateIpWhitelistAddress,
} from '@/features/ip_address_whitelists/utils/validateIpWhitelistAddress';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

export type IpAddressWhitelistIpRules = {
  required: string;
  validate: (value: string) => true | string;
};

const messageKeyByError: Record<
  IpWhitelistAddressValidationError,
  | 'ip_address_whitelist_validation_ip_required'
  | 'ip_address_whitelist_validation_ip_too_short'
  | 'ip_address_whitelist_validation_ip_too_long'
  | 'ip_address_whitelist_validation_ip_invalid'
> = {
  empty: 'ip_address_whitelist_validation_ip_required',
  'too-short': 'ip_address_whitelist_validation_ip_too_short',
  'too-long': 'ip_address_whitelist_validation_ip_too_long',
  'invalid-format': 'ip_address_whitelist_validation_ip_invalid',
};

export const useIpAddressWhitelistIpRules = (): IpAddressWhitelistIpRules => {
  const { t } = useTranslation();
  return useMemo(
    () => ({
      required: t('ip_address_whitelist_validation_ip_required'),
      validate: (value: string) => {
        const error = validateIpWhitelistAddress(value);
        return error === null ? true : t(messageKeyByError[error]);
      },
    }),
    [t]
  );
};
